import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,
  IonButton
  } from '@ionic/react';
import React from 'react';
import './Logout.css';
import ServerService from '../services/Server';


const Logout: React.FC = () => {

const name:string = "Log Out";

const server = new ServerService();

return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <div className="center-container">
          <div className="icon-wrapper">
            <div className="icon-logout"></div>
          </div>
          
          <h1>Log Out?</h1>
          <p>Are you sure you want to log out from this account?</p>

          <IonButton
              className="btn-logout"
              color="danger"
              size="large"
              onClick={(e) => {
                server.logout();
                window.location.href = "/page/settings/accounts/account/"+server.activeAcc;
              }}>
              Confirm Log Out
          </IonButton>
        </div>

      </IonContent>
    </IonPage>
    );
};

export default Logout;
